import AppErrorView from './AppErrorView';

// Top-level react-error-boundary fallback (outside the router).
export default function ErrorFallback({ error }) {
  return <AppErrorView error={error} />;
}
